import { inject, InjectionToken } from '@angular/core';
import { WINDOW } from './window';

export const LOCATION: InjectionToken<Location> = new InjectionToken<Location>(
  'An abstraction over window.location object',
  {
    factory: () => inject(WINDOW).location,
  }
);
